import PeerVideo from '@components/PeerVideo';
import type { BaseComponentProps } from '@interfaces/selection';
import { useRemoteVideoTileState } from '@providers/RemoteVideoTileProvider';
import { useRosterState } from '@providers/RosterProvider';
import { type FC, type PropsWithChildren, useEffect } from 'react';
import { Container, ListContainer } from './style';

const PeerVideos: FC<PropsWithChildren<BaseComponentProps>> = (props) => {
  const { roster, attendees } = useRosterState();
  const { tiles, tileIdToAttendeeId, attendeeIdToTileId } =
    useRemoteVideoTileState();

  useEffect(() => {
    console.log('-------------------------------------------');
    console.log('roster:', roster);
    console.log('tiles:', tiles);
    console.log('tileIdToAttendeeId:', tileIdToAttendeeId);
    console.log('attendeeIdToTileId:', attendeeIdToTileId);
  }, [roster, tileIdToAttendeeId, tiles]);

  const getPeerVideoEls = () => {
    return tiles
      .filter((tileId) => {
        const attendee = roster[tileIdToAttendeeId[tileId]] || {};
        const type = attendees.find(
          (dto) => dto.key === attendee?.externalUserId,
        )?.type;
        return type === 'interviewer';
      })
      .map((tileId) => {
        const attendee = roster[tileIdToAttendeeId[tileId]] || {};
        const name =
          attendees.find((dto) => dto.key === attendee?.externalUserId)?.name ||
          '';
        const attendeeId = attendee?.chimeAttendeeId;
        return (
          <PeerVideo
            {...props}
            key={tileId}
            tileId={tileId}
            name={name}
            attendeeId={attendeeId}
          />
        );
      });
  };

  return (
    <Container>
      <ListContainer>{getPeerVideoEls()}</ListContainer>
    </Container>
  );
};

export default PeerVideos;
